<script setup lang="ts">
import { classname } from '@/js/utils.ts';

defineProps<{
  size?: 'sm'
}>();

const cn = classname('base-loader');
</script>

<template>
  <div :class="cn({ size })" />
</template>

<style lang='scss'>
.base-loader {
  border: 10px solid #f3f3f3;
  border-top: 10px solid var(--light-primary-color);
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 2s linear infinite;

  &_size {
    &_sm {
      width: 20px;
      height: 20px;
      border: 4px solid #f3f3f3;
      border-top: 4px solid var(--light-primary-color);
    }
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
